import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-surface py-12 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-89" data-mp="4vs0dxwxedqv">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-90" data-mp="9t1mb3l3w79y">
        <Medallion icon={ShieldCheckIcon} data-id="element-91" data-mp="etpngi31u4hw" />

        <p className="mt-6 font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-accent" data-id="element-92" data-mp="euqwyi4f2ixi">Garanzia 7 giorni</p>
        <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-serif text-[2.2rem] font-bold leading-[1.05] text-ink sm:text-[2.6rem]" data-id="element-93" data-mp="nu49xkrr1pmz">
          Senza rischio
        </h2>

        <p className="mx-auto mt-6 max-w-prose font-sans text-base leading-relaxed text-muted" data-id="element-94" data-mp="smxdi5bherxh">
          Accedi a Yoga Kit Pro™, esplora i 6 volumi, prova i bonus. Usa il
          materiale nella tua classe più impegnativa questa settimana.
        </p>
        <p className="mx-auto mt-4 max-w-prose font-sans text-base leading-relaxed text-muted" data-id="element-95" data-mp="17j6b72fq4x7s">
          Se scopri che non è quello che ti aspettavi, contattaci entro 7 giorni
          e ti rimborsiamo il{' '}
          <span className="font-semibold text-ink" data-id="element-96" data-mp="20s2fgbyk9qa8">100% dell'importo</span>.
          Nessuna domanda. Nessun modulo complicato.
        </p>
        <p className="mx-auto mt-6 max-w-prose font-serif text-2xl font-bold leading-snug text-accent" data-id="element-97" data-mp="1rs5og3op8fc0">
          Perché se il materiale non offre il valore che promettiamo, non
          vogliamo tenere i tuoi soldi.
        </p>
      </div>
    </section>;
}